import React from 'react';

const DVMContext = React.createContext({});

export default DVMContext;
